import { Injectable } from '@angular/core';

export class StorageOptions {
  explicitExpiresOn?: Date;
  neverExpires?: boolean;
}

@Injectable()
export class StorageService {

  private version: number = 1;
  private checkedForExpirations: boolean = false;

  constructor(
  ) {
  }

  private checkForExpirations(userId: string) : void {
    if (!this.checkedForExpirations) {
      try {
        for (var i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);

          if (key.startsWith(userId)) {
            const val = localStorage.getItem(key);

            if (val) {
              var result = JSON.parse(val);

              if (!result.ExpiresOn || result.Version != this.version) {
                localStorage.removeItem(key);
                i--;
              } else {
                const expiresOn = new Date(result.ExpiresOn);

                if (!expiresOn || expiresOn < new Date()) {
                  localStorage.removeItem(key);
                  i--;
                }
              }
            }
          }
        }
      } catch (e) {
        console.log(e.message);
      }

      this.checkedForExpirations = true;
    }
  }

  private getDefaultExpiresOn(): Date {
    let tempDate = new Date();
    tempDate.setDate(tempDate.getDate() + 2);
    tempDate.setHours(0, 0, 0, 0);

    return tempDate;
  }

  private getNeverExpiresOn(): Date {
    let tempDate = new Date('2099-01-01');

    return tempDate;
  }

  public saveData(userId: string, key: string, value: any, options?: StorageOptions) {
    if (!key)
      return;

    this.checkForExpirations(userId);

    let expiresOn: Date;
    if (options && options.explicitExpiresOn)
      expiresOn = options.explicitExpiresOn;
    else if (options && options.neverExpires)
      expiresOn = this.getNeverExpiresOn();
    else
      expiresOn = this.getDefaultExpiresOn();

    localStorage.setItem(userId + ':' + key, JSON.stringify({
      InsertedOn: new Date(),
      ExpiresOn: expiresOn,
      Version: this.version,
      Value: value
    }));
  }

  public getData(userId: string, key: string): any {
    if (!key)
      return null;

    this.checkForExpirations(userId);

    var val = localStorage.getItem(userId + ':' + key);

    if (val) {
      var result = JSON.parse(val);

      if (result) {
        return result.Value;
      }
    }

    return null;
  }
}
